export default __webpack_public_path__ + "static/media/layout-2.ce57b1da.jpg";